module.exports = __webpack_public_path__ + "img/pro_3.0e078485.png";